import React from 'react';
import { getlanguagelist } from "../../../helpers/changelanguage";

const LoginRegBox = ({lang,children }) => {
    let copyright = (lang != undefined) ? lang.copyright : '';
    return(
        <div className="col-lg-5">
              <div className="login_reg_box">
                  {children}
              </div>
    <p className="text-center copyright_text">
    {/* {copyright}©BaalDahab, {new Date().getFullYear()} */}
    </p>
        </div>
    )
};

export default LoginRegBox;